export default __webpack_public_path__ + "static/media/big-hair-bg.fe249477.png";